import { StateCreator } from 'zustand';
import { UIStore } from '../ui-store';
import { GlobalAction, GlobalSlice } from './global-ui-slice.types';

const initialGlobalState = {
  isLoading: false,
  loadingTitle: '',
  isToasterOpen: false,
  toasterTitle: '',
  toasterChildren: '',
  toasterVariant: undefined,
  toasterOwner: undefined,
};

export const createGlobalSlice: StateCreator<UIStore, [['zustand/devtools', never]], [], GlobalSlice> = (set, get) => ({
  ...initialGlobalState,
  showLoadingScreen: (title: string) =>
    set({ isLoading: true, loadingTitle: title }, false, GlobalAction.ShowLoadingScreen),
  hideLoadingScreen: () => set({ isLoading: false, loadingTitle: '' }, false, GlobalAction.HideLoadingScreen),
  openToaster: (payload, owner) =>
    set(
      {
        isToasterOpen: true,
        toasterTitle: payload.title,
        toasterChildren: payload.children,
        toasterVariant: payload.variant,
        toasterOwner: owner,
      },
      false,
      GlobalAction.OpenToaster,
    ),
  closeToaster: (owner) => {
    if (owner && get().toasterOwner !== owner) return;
    set(
      {
        isToasterOpen: false,
        toasterTitle: '',
        toasterChildren: '',
        toasterVariant: undefined,
        toasterOwner: undefined,
      },
      false,
      GlobalAction.CloseToaster,
    );
  },
});
